class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default properties
    this._threshold = 7500; // $75.00 in cents
    this._current = 0;
    this._currency = '$';
    this._thresholdMessage = 'Add __AMOUNT__ more to get FREE shipping!';
    this._successMessage = 'Congratulations! You qualify for FREE shipping!';
    this._progressColor = '#4CAF50';
    this._backgroundColor = '#f0f0f0';
  }

  static get observedAttributes() {
    return [
      'threshold', 
      'current', 
      'currency', 
      'threshold-message', 
      'success-message',
      'progress-color',
      'background-color'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch(name) {
      case 'threshold':
        this._threshold = parseInt(newValue, 10);
        break;
      case 'current':
        this._current = parseInt(newValue, 10);
        break;
      case 'currency':
        this._currency = newValue;
        break;
      case 'threshold-message':
        this._thresholdMessage = newValue;
        break;
      case 'success-message':
        this._successMessage = newValue;
        break;
      case 'progress-color':
        this._progressColor = newValue;
        break;
      case 'background-color':
        this._backgroundColor = newValue;
        break;
    }
    
    this.render();
  }

  connectedCallback() {
    // Get attributes on initial render
    if (this.hasAttribute('threshold')) {
      this._threshold = parseInt(this.getAttribute('threshold'), 10);
    }
    
    if (this.hasAttribute('current')) {
      this._current = parseInt(this.getAttribute('current'), 10);
    }
    
    if (this.hasAttribute('currency')) {
      this._currency = this.getAttribute('currency');
    }
    
    if (this.hasAttribute('threshold-message')) {
      this._thresholdMessage = this.getAttribute('threshold-message');
    }
    
    if (this.hasAttribute('success-message')) {
      this._successMessage = this.getAttribute('success-message');
    }
    
    if (this.hasAttribute('progress-color')) {
      this._progressColor = this.getAttribute('progress-color');
    }
    
    if (this.hasAttribute('background-color')) {
      this._backgroundColor = this.getAttribute('background-color');
    }
    
    this.render();
  }

  formatCurrency(cents) {
    return this._currency + (cents / 100).toFixed(2);
  }

  render() {
    // Calculate progress bar values
    const progressPercentage = Math.min(100, (this._current / this._threshold) * 100);
    const remainingAmount = Math.max(0, this._threshold - this._current);
    const formattedAmount = this.formatCurrency(remainingAmount);
    const formattedStartAmount = this.formatCurrency(0);
    const formattedEndAmount = this.formatCurrency(this._threshold);
    // Create HTML content
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .progress-container {
          margin: 0;
          padding: 0;
          border-radius: 0px;
          background-color: white;
          margin-bottom:15px;
        }
        
        .progress-message {
          margin-bottom: 5px;
          text-align: left;
          font-size: 14px;
          line-height: 120%;
        }
        
        
        .progress-bar {
          height: 5px;
          background-color: ${this._backgroundColor};
          border-radius: 21px;
          overflow: hidden;
          position: relative;
        }
        
        .progress-fill {
          height: 100%;
          width: ${progressPercentage}%;
          background-color: ${this._progressColor};
          border-radius: 5px;
          transition: width 0.4s ease-in-out;
        }
        .progress-remaining{
          font-weight:600;
        }
        .custom-bottom-amount {
            display: none;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }
      </style>
      
      <div class="progress-container">
        <div class="progress-message">
          ${remainingAmount > 0 
            ? this._thresholdMessage.replace('__AMOUNT__', `<span class="progress-remaining">${formattedAmount}</span>`)
            : `<span class="progress-complete">${this._successMessage}</span>`
          }
        </div>
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
        <div class="custom-bottom-amount">
          <span>${formattedStartAmount}</span>
          <span>${formattedEndAmount}</span>
        </div>
      </div>
    `;
  }
}


// Register the custom element
customElements.define('shipping-progress-bar', ShippingProgressBar);
 function initCartDrawerUpsell() {
   cartDrawerCountdown();
    // Initialize Slick slider
    $('.cart-drawer-upsell__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      appendDots: $('.cart-drawer-upsell__dots'),
      infinite: false,
      adaptiveHeight: false
    });
    
  }
document.addEventListener('DOMContentLoaded', function() {
  cartDrawerCountdown();
  initCartDrawerUpsell();
});
subscribe(PUB_SUB_EVENTS.cartUpdate, async function(event) {
    cartDrawerCountdown();
  setTimeout(initCartDrawerUpsell,1000);
    /*if (event.cartData) {
     
      if (event.cartData.item_count === 0) {
        // Cart is empty, stop timer
        stopTimer();
      } else {
         
        // Cart has items and timer is not active, start timer
        timeRemaining = TOTAL_TIME; // Reset to full time
        countdownWrapper.style.display = '';
        timerActive = false;
        updateTimerDisplay();
        startTimer();
      }
    } else {
      // If event.detail.cart is not available, check cart manually
      const hasItems = await checkCartHasItems();
      if (!hasItems) {
        stopTimer();
      } else if (!timerActive) {
        timeRemaining = TOTAL_TIME;
        countdownWrapper.style.display = '';
        timerActive = false;
        updateTimerDisplay();
        startTimer();
      }
    }*/
    
  });
// Cart Drawer Countdown Timer
const cartDrawerCountdown =  () =>  {
  // Select the countdown wrapper element
  const countdownWrapper = document.querySelector('.custom-countdown-wrapper');
  
  // If countdown element doesn't exist, exit early
  if (!countdownWrapper) return;
  
  // Get total minutes from data-time attribute and convert to seconds
  const totalMinutes = parseInt(countdownWrapper.getAttribute('data-time') || 10, 10);
  const TOTAL_TIME = totalMinutes * 60; // Convert minutes to seconds
  
  // Select the countdown display element
  const timerDisplay = countdownWrapper.querySelector('.custom-countdown-main');
  
  // If timer display doesn't exist, exit early
  if (!timerDisplay) return;
  
  // Timer state variables
  let timeRemaining;
  let timerInterval;
  let timerActive = false;
  
  // Function to check if cart has items
  async function checkCartHasItems() {
    try {
      // Fetch cart data from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count > 0;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }
  
  // Initialize timer
  initializeTimer();
  
  // Functions
  async function initializeTimer() {
    // Check if cart has items first
    const hasItems = await checkCartHasItems();
    
    if (!hasItems) {
      // Hide countdown if cart is empty
      countdownWrapper.style.display = 'none';
      clearCartTimerStorage();
      return;
    }
    
    // Check if there's a stored timer value in sessionStorage
    const storedTimeStamp = sessionStorage.getItem('cartTimerExpiry');
    const storedTimeRemaining = sessionStorage.getItem('cartTimeRemaining');
    
    if (storedTimeStamp && storedTimeRemaining) {
      const now = Date.now();
      const expiry = parseInt(storedTimeStamp, 10);
      
      // Calculate how much time has passed since the timer was paused
      if (now < expiry) {
        // Timer was still running, calculate remaining time
        timeRemaining = Math.round((expiry - now) / 1000);
      } else {
        // Timer expired since last visit
        timeRemaining = 0;
      }
    } else {
      // First time initialization
      timeRemaining = TOTAL_TIME;
    }
    
    // If timer is at 0, reset it to full time
    if (timeRemaining <= 0) {
      timeRemaining = TOTAL_TIME;
    }
    
    // Make countdown visible
    countdownWrapper.style.display = '';
    
    // Update display and start timer
    setTimeout(() => {
      updateTimerDisplay();
      startTimer();
    },100);
    
  }
  
  function startTimer() {
    console.log(timerActive,"timerActive",!timerActive);
    if (!timerActive) {
      timerActive = true;
      
      // Store the expected end time
      const expiryTime = Date.now() + (timeRemaining * 1000);
      sessionStorage.setItem('cartTimerExpiry', expiryTime);
      
      timerInterval = setInterval(function() {
        timeRemaining--;
        updateTimerDisplay();
        
        // Update sessionStorage every second
        sessionStorage.setItem('cartTimeRemaining', timeRemaining);
        sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
        
        if (timeRemaining <= 0) {
          // Timer completed
          handleTimerComplete();
        }
      }, 1000);
    }
  }
  
  function stopTimer() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage
    clearCartTimerStorage();
  }
  
  function updateTimerDisplay() {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    
    // Format time as MM:SS
    timerDisplay.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  function handleTimerComplete() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage for cart timer
    clearCartTimerStorage();
  }
  
  function clearCartTimerStorage() {
    // Remove all cart timer related items from sessionStorage
    sessionStorage.removeItem('cartTimeRemaining');
    sessionStorage.removeItem('cartTimerExpiry');
  }
  // Shopify specific - listen for cart updates
  
  
  // Alternative approach for Shopify - monitor Ajax requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    
    // Check if this is a cart update
    if (url && typeof url === 'string') {
      if (url.includes('/cart/clear.js') || url.includes('/cart/clear')) {
        // Cart clear request
        promise.then(() => {
          stopTimer();
        });
      } else if (url.includes('/cart/add.js') || url.includes('/cart/add') || 
                url.includes('/cart/update.js') || url.includes('/cart/update') ||
                url.includes('/cart/change.js') || url.includes('/cart/change')) {
        // Cart addition/update request
        promise.then(async (response) => {
          const hasItems = await checkCartHasItems();
          if (hasItems && !timerActive) {
            timeRemaining = TOTAL_TIME;
            countdownWrapper.style.display = '';
            updateTimerDisplay();
            startTimer();
          }
        });
      }
    }
    
    return promise;
  };
  
  // No visibility change handling - countdown continues running in background
  
  // Function to handle window unload (close/refresh)
  window.addEventListener('beforeunload', function() {
    if (timerActive) {
      sessionStorage.setItem('cartTimeRemaining', timeRemaining);
      sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
    }
  });
}
const updateSubscriptionPrice = (variantID) => {
  const containerElement = $(`input[skio-selling-plan-group]`).parents(".skio-group-container");
  const onetimeElement = $(`input[skio-one-time]`).parents(".skio-group-container");
  
  const variant = customVariantJSON.filter(variant => variant.id == variantID);
  if(variant.length >0){
    if(containerElement.find(".skio-price .original-price").length <= 0){
      containerElement.find(".skio-price").addClass("discount-sale-price");
      containerElement.find(".skio-price").append(`<span class="original-price" skio-subscription-price>${variant[0].priceHTML}</span>`);
    }else{
      containerElement.find(".skio-price .original-price").text(variant[0].priceHTML);
    }
    if(variant[0].compareprice > variant[0].price ){
      if(onetimeElement.find(".skio-price .original-price").length <= 0){
        onetimeElement.find(".skio-price").addClass("discount-sale-price");
        onetimeElement.find(".skio-price").append(`<span class="original-price" skio-subscription-price>${variant[0].comparepriceHTML}</span>`);
      }else{
        onetimeElement.find(".skio-price .original-price").text(variant[0].comparepriceHTML);
      }
    }
    
    
  }
  
}
subscribe(PUB_SUB_EVENTS.variantChange,(event) => {
  if(event?.data?.variant){
    updateSubscriptionPrice(event?.data?.variant.id);
     const subscriptionSelected = document.querySelector(".custom-subscription-selector-wrapper label.pouch-option.selected");
      if(subscriptionSelected){
        if(subscriptionSelected.dataset.value == 'subscribe'){
          subscriptionSelected.click();
        }
      }
      
  }
});
var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  });
function initFlavorSlider() {
  var slider = document.querySelector(".sunna-flavour-slider");
  if (!slider) return;

  // Check if slider is already initialized
  if (slider.classList.contains("slick-initialized")) {
    slider.slick("unslick");
  }

  // Only initialize on tablet/mobile
  if (window.innerWidth <= 1023) {
    // Initialize Slick slider
    $(slider).slick({
      dots: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    setEqualHeights(slider);

    // Set equal heights after slide change
    $(slider).on("afterChange", function () {
      setEqualHeights(slider);
    });
  }
}
// Function to handle resize
function handleResize() {
  var slider = document.querySelector(".sunna-flavour-slider");
  if (!slider) return;

  if (window.innerWidth <= 1023) {
    // Initialize or position slider on tablet/mobile
    if (slider.classList.contains("slick-initialized")) {
      $(slider).slick("setPosition");
    } else {
      initFlavorSlider();
    }
    // Show slider, hide grid
    document.querySelector(".sunna-flavour-slider-container").style.display =
      "block";
    document.querySelector(".sunna-flavour-grid").style.display = "none";
  } else {
    // Destroy slider on desktop
    if (slider.classList.contains("slick-initialized")) {
      $(slider).slick("unslick");
    }
    // Show grid, hide slider
    document.querySelector(".sunna-flavour-slider-container").style.display =
      "none";
    document.querySelector(".sunna-flavour-grid").style.display = "grid";
  }
}
function setEqualHeights(slider) {
  if (!slider) return;

  // Reset heights first
  var cards = slider.querySelectorAll(".sunna-flavour-card");
  cards.forEach(function (card) {
    card.style.height = "auto";
  });

  // Get max height
  var maxHeight = 0;
  cards.forEach(function (card) {
    var height = card.offsetHeight;
    maxHeight = height > maxHeight ? height : maxHeight;
  });

  // Set equal height to all cards
  if (maxHeight > 0) {
    cards.forEach(function (card) {
      card.style.height = maxHeight + "px";
    });
  }
}
jQuery(document).ready(function ($) {
  
  $('.custom-review-slide-main-right-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: false,
    
      prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.7273" cy="12.7273" r="12.2273" transform="matrix(-1 0 0 1 26.7273 1.27246)" stroke="#1D1D1D"/>
        <path d="M15.9435 9.51172C15.8071 9.37524 15.5869 9.37524 15.4504 9.51172L11.2082 13.7539C11.0718 13.8903 11.0719 14.1095 11.2082 14.2461L15.4504 18.4893C15.5185 18.5574 15.6078 18.5908 15.6974 18.5908C15.7869 18.5907 15.8755 18.5572 15.9435 18.4893C16.08 18.3528 16.08 18.1326 15.9435 17.9961L11.9474 14L15.9435 10.0039C16.0797 9.8675 16.0797 9.64815 15.9435 9.51172Z" stroke="#1D1D1D"/>
        </svg>
        </button>`,
      nextArrow: `<button type="button" class="slick-next" aria-label="Next">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="13.9997" r="12.2273" stroke="#1D1D1D"/>
          <path d="M12.0565 9.51172C12.193 9.37524 12.4132 9.37524 12.5497 9.51172L16.7919 13.7539C16.9282 13.8903 16.9281 14.1095 16.7919 14.2461L12.5497 18.4893C12.4815 18.5574 12.3923 18.5908 12.3026 18.5908C12.2131 18.5907 12.1245 18.5572 12.0565 18.4893C11.92 18.3528 11.9201 18.1326 12.0565 17.9961L16.0526 14L12.0565 10.0039C11.9203 9.8675 11.9204 9.64815 12.0565 9.51172Z" stroke="#1D1D1D"/>
          </svg>
        </button>`,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          },
         {
              breakpoint: 930,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
      ]
  });
  $(document).on("change",".custom-supplement-flavors-dropdown",function(){
    const currentSelected = $(this).val();
    $(".custom-accordion-img-wrapper").addClass("hidden");
    if(currentSelected > 0){
      $(`.custom-accordion-img-wrapper[data-index="${currentSelected}"]`).removeClass("hidden");
    }
  });
  $(document).on('change',`.skio-group-input`,function(){
    console.log("plane selection done");
    if($.trim($(this).val()).length > 0){
      $(".product-form__quantity").addClass("hidden");
      $(".quantity__input").val(1);
    }else{
      $(".product-form__quantity").removeClass("hidden");
    }
  });
  if($(`input[name="selling_plan"]`).length > 0){
    if($.trim($(`input[name="selling_plan"]`).val()).length > 0){
      $(".product-form__quantity").addClass("hidden");
      $(".quantity__input").val(1);
    }else{
      $(".product-form__quantity").removeClass("hidden");
    }
  }
  
   // Initialize on load
  initFlavorSlider();
  handleResize();
  $(".halal-collagen-feature-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: `<button type="button" class="slick-prev" aria-label="Previous"><svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" transform="matrix(-1 0 0 1 40 0.5)" fill="white"/>
<path d="M22.5 15.5L17.5 20.5L22.5 25.5" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>`,
    nextArrow: `<button type="button" class="slick-next" aria-label="Next"><svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" transform="translate(0 0.5)" fill="white"/>
<path d="M17.5 15.5L22.5 20.5L17.5 25.5" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if(typeof customVariantJSON !== 'undefined' && customVariantJSON.length > 0){
    const skioWidgetInterval = setInterval(() => {
      if(document.querySelector(`input[skio-selling-plan-group]`)){
        const variant = document.querySelector(".product-variant-id").value;
        updateSubscriptionPrice(variant)
        clearInterval(skioWidgetInterval);
      }
    },1000);
    
  }
  $(document).on('click','.custom-remove-item', function(evt) {
      const button = $(this);
      const main_item_key = button.data('key');
      const bundle_id = button.data("bundleid");
      const itemSelector = `.cart-item[data-bundleid="${bundle_id}"][data-ismain="0"]`;
        let items = [];
        console.log(document.querySelectorAll(itemSelector),"itemSelector");
        document.querySelectorAll(itemSelector).forEach((el) => {
          items.push({
            id: `${el.dataset.key}`,
            quantity:0
          });
        });
       items.push({
          id: `${main_item_key}`,
          quantity:0
        });
        
       let updates = items.reduce((acc, { id, quantity }) => {
            acc[id] = quantity;
            return acc;
        }, {});
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      button.attr('disabled', true);
      
      // Add item to cart
      const formData = {
        updates,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
     fetch(`/cart/update.js`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
     })
      .then((response) => response.json())
      .then((response) => {
        CartPerformance.measure("add:paint-updated-sections", () => {
        cart.renderContents(response);
      });
        button.attr('disabled', false);
        cart.classList.toggle('is-empty', response.item_count === 0);
      })
      .catch(error => {
        console.error('Error:', error);
        button.attr('disabled', false);
      }).finally(() => {
          CartPerformance.measureFromEvent("add:user-action", evt);
      });
    });
   $(document).on('click','.cart-drawer-upsell__add', function() {
      const button = $(this);
      const productId = button.data('product-id');
       const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
       
      button.attr('disabled', true);
      
      // Add item to cart
      const formData = {
        'items': [{
          'id': productId,
          'quantity': 1
        }],
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
     fetch(`/cart/add.js`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
     })
          .then((response) => response.json())
          .then((response) => {
        CartPerformance.measure("add:paint-updated-sections", () => {
        cart.renderContents(response);
          setTimeout(initCartDrawerUpsell,500);
      });
        button.attr('disabled', false);
      })
      .catch(error => {
        console.error('Error:', error);
        button.attr('disabled', false);
      });
    });
  document.querySelectorAll('.custom-anchor-point label').forEach(label => {
  label.addEventListener('click', function() {
    // Get the target ID from the data-target attribute
    const targetId = this.getAttribute('data-target');
    
    // Find the target element using the ID
    const targetElement = document.getElementById(targetId);
    
    // If target element exists, scroll to it with smooth behavior
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});
  $(".custom-hero-image-slider").slick({
    dots: true,
    arrow: false,
  });
  $(".supplements-difference-wrapper").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if (window.innerWidth < 1024) {
    $(".announcement-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      infinite: true,
      cssEase: "linear",
      speed: 10000,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  }

  // Reinitialize slick on window resize if needed
  $(window).resize(function () {
    if (
      window.innerWidth < 1024 &&
      !$(".announcement-slider").hasClass("slick-initialized")
    ) {
      $(".announcement-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: false,
        dots: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        infinite: true,
        cssEase: "linear",
        speed: 10000,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    } else if (
      window.innerWidth >= 1024 &&
      $(".announcement-slider").hasClass("slick-initialized")
    ) {
      $(".announcement-slider").slick("unslick");
    }
  });
});
function goto_loox_section() {
    $('html, body').animate({
        scrollTop: $("#looxReviews").offset().top - 100
    }, 2000);
}

class CustomTimerCountdown extends HTMLElement {
    constructor() {
        super();
        this.interval = null;
        this.endTime = null;
        this.storageKey = 'countdown-timer-end';
    }

    connectedCallback() {
        this.initTimer();
    }

    disconnectedCallback() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    initTimer() {
        const storedEndTime = localStorage.getItem(this.storageKey);
        const now = Date.now();

        if (storedEndTime) {
            const endTime = parseInt(storedEndTime);
            const remaining = endTime - now;

            if (remaining > 0) {
                // Continue with remaining time
                this.endTime = endTime;
                this.startCountdown();
                return;
            }
        }

        // Start new timer
        this.startTimer();
    }

    startTimer() {
        const hours = parseInt(this.getAttribute('data-hours')) || 2;
        const duration = hours * 60 * 60 * 1000;
        
        this.endTime = Date.now() + duration;
        localStorage.setItem(this.storageKey, this.endTime.toString());
        
        this.startCountdown();
    }

    startCountdown() {
        this.updateDisplay();
        
        if (this.interval) {
            clearInterval(this.interval);
        }
        
        this.interval = setInterval(() => {
            this.updateDisplay();
        }, 1000);
    }

    updateDisplay() {
        const now = Date.now();
        const remaining = this.endTime - now;

        if (remaining <= 0) {
            this.startTimer();
            return;
        }

        const hours = Math.floor(remaining / (1000 * 60 * 60));
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

        const hoursNode = this.querySelector('.hours .timer-node');
        const minutesNode = this.querySelector('.minutes .timer-node');
        const secondsNode = this.querySelector('.seconds .timer-node');

        if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
        if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
        if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
    }
}

customElements.define('custom-timer-countdown', CustomTimerCountdown);


// Detect sub parameter and auto-enable subscription
(function() {
    const urlParams = new URLSearchParams(window.location.search);
    const subParam = urlParams.get('sub');
    
    if (subParam === '1') {
        // Wait for elements to load
        const checkInterval = setInterval(function() {
          const subscriptionElement = document.querySelector(".subsribe-option-wrapper");
            // Try to find subscription toggle/checkbox
            if (subscriptionElement) {
               subscriptionElement.dispatchEvent(new Event("click"));
                clearInterval(checkInterval);
            }
        }, 100);
        
        // Stop checking after 5 seconds
        setTimeout(() => clearInterval(checkInterval), 5000);
    }
})();